export default __webpack_public_path__ + "static/media/Vector.3e1ef394.svg";